import React from 'react';
import EntityFiles from '../EntityFiles';

// Service Order Files tab — backed by the shared Document Library. Shows files
// linked to this service order (including legacy files keyed by stock) and lets
// the user add more, pre-linked to the order.
export default function FilesTab({ order, stockNumber }) {
  const id = stockNumber;
  const car = [order?.year, order?.make, order?.model].filter(Boolean).join(' ');
  const label = `SO ${id}${car ? ` — ${car}` : ''}`;
  const customer = order?.customer || {};
  const signContacts = customer.email
    ? [{ label: 'Customer', email: customer.email, name: [customer.first_name, customer.last_name].filter(Boolean).join(' ').trim() }]
    : [];

  return (
    <EntityFiles
      type="serviceOrder"
      id={id}
      legacyStock={id}
      label={label}
      signContacts={signContacts}
    />
  );
}
